export default __webpack_public_path__ + "static/media/productlisting.d54c62d6.jpg";